import { apiSlice } from "../../app/api/apiSlice"
import { GetWorkerListingQueryParameterModel, WorkerAsDropdownListItemModel, WorkerDetailModel, WorkerListingModel, WorkerModel } from "../../models/WorkerModel"
import { generateFormatedURL } from "../../utils/urlFormatter"

export const workerApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({

        getWorkerDropdownList: builder.query<any, void>({
            query: () => "/Worker/DropdownList",
        }),

        getWorkerListing: builder.query({
            query: (args) => "/Worker".concat(generateFormatedURL(args)),
        }),

        getWorkerDetail: builder.query<WorkerDetailModel, string>({
            query: (id) => "/Worker/".concat(id),
        }),

        getWorkerFile: builder.query<string, string>({
            query: (id) => ({
                url: '/Worker/file/'.concat(id),
                responseHandler: (response) =>
                    response.blob().then((blob) => URL.createObjectURL(blob)),
            }),
        }),

        getFile: builder.query<any, string>({
            query: (id) => {
                return {
                    url: `/Worker/file/${id}`,
                    responseHandler: async (response) => {
                        const blob = await response.blob();
                        var blobUrl = URL.createObjectURL(blob);
                        return { url: blobUrl };
                    },
                }
            }
        }),

        createWorker: builder.mutation<any, FormData>({
            query: (formData) => ({
                url: '/Worker',
                method: 'POST',
                body: formData,
                formData: true
            })
        }),

        updateWorker: builder.mutation<any, { id: string, formData: FormData }>({
            query: (body) => ({
                url: '/Worker/'.concat(body.id),
                method: 'PUT',
                body: body.formData,
                formData: true
            })
        }),
    })
})

export const {
    useLazyGetWorkerDropdownListQuery,
    useGetWorkerDropdownListQuery,
    useLazyGetWorkerListingQuery,
    useLazyGetWorkerDetailQuery,
    useLazyGetWorkerFileQuery,
    useCreateWorkerMutation,
    useUpdateWorkerMutation,
    useLazyGetFileQuery
} = workerApiSlice  